import useInput from "skin/entry/hook/input2";

export default function useFormInput() {
	const [login, , onChangeLogin, errLogin, setErrLogin] = useInput('');
	const [password, , onChangePassword, errPassword, setErrPassword] = useInput('');
	const [password2, , onChangePassword2, errPassword2, setErrPassword2] = useInput('');
	const [phone, setPhone, , errPhone, setErrPhone] = useInput('');
	const [source, setSource, , errSource, setErrSource] = useInput('');

	const value = {};
	value.login = login;
	value.password = password;
	value.password2 = password2;
	value.phone = phone;
	value.source = source;

	const handlers = {};
	handlers.login = onChangeLogin;
	handlers.password = onChangePassword;
	handlers.password2 = onChangePassword2;
	handlers.phone = setPhone;
	handlers.source = setSource;

	const err = {};
	err.login = errLogin;
	err.password = errPassword;
	err.password2 = errPassword2;
	err.phone = errPhone;
	err.source = errSource;

	const setErr = {};
	setErr.login = setErrLogin;
	setErr.password = setErrPassword;
	setErr.password2 = setErrPassword2;
	setErr.phone = setErrPhone;
	setErr.source = setErrSource;

	return { value, handlers, err, setErr };
}